module.exports = new __parcel__URL__("contract.e250ed6b.png").toString();